<template>
  <div class="content-dashboard">
    <h3>{{ $t("dashboard.key_stats") }}</h3>

    <div class="mt-3 row mb-4">
      <div class="col-lg-4">
        <div class="box-chart">
          <h4>{{ $t("dashboard.orders_in_progress") }}</h4>

          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex gap-2">
              <span class="number">3</span>
              <p>{{ $t("dashboard.orders_in_preparation") }}</p>
            </div>

            <span class="icon-down"><img :src="iconDown" /></span>
          </div>
        </div>
      </div>

      <div class="col-lg-4">
        <div class="box-chart">
          <h4>{{ $t("dashboard.track_deliveries") }}</h4>

          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex gap-2">
              <span class="number">4</span>
              <p v-html="$sanitize.sanitizeI18nContent($t('dashboard.deliveries_in_progress'))"></p>
            </div>

            <span class="icon-down"><img :src="iconDown" /></span>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="box-chart">
          <h4>{{ $t("dashboard.notifications") }}</h4>

          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex gap-2">
              <p>{{ $t("dashboard.new_document") }}</p>
            </div>

            <span class="icon-down"><img :src="iconDown" /></span>
          </div>
        </div>
      </div>
    </div>

    <div class="mb-3 row">
      <div class="col-lg-12">
        <img :src="chart" />
      </div>
    </div>
  </div>
</template>

<script>
  import chart from "@/assets/images/chart.png";
  import iconDown from "@/assets/images/icon-row-down.svg";
  export default {
    name: "TableauBord",
    data() {
      return {
        chart,
        iconDown,
      };
    },
  };
</script>
